import React from "react";
import { motion } from "framer-motion";
import { useHistory, useLocation } from "react-router";
import { useState, useEffect } from "react";
import swal from "sweetalert";
import {
    GetAllCompanyData,
    GetCompanyDataIR,
    deleteOthersDetailsIr,
    getAllIR,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu"
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as FilterIcon } from "../../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as DownloadIcon } from "../../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";

const IRDetails = () => {
    //
    const [age, setAge] = React.useState("");

    const handleChange = (event) => {
        setAge(event.target.value);
    };
    //
    const history = useHistory();
    const [allIr, setAllIR] = useState([]);
    const [IrData, setIrData] = useState([]);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const [IrOneData, setIRData] = useState("");
    const location = useLocation();
    let a = location.pathname;
    let b = a.split("/");

    const [allCompany, setAllCompany] = useState([]);
    const [data, setData] = useState("");

    const registerID = b[2]

    useEffect(() => {
        getAllIrData();
        // allIrData();
        AllRegisterData();
        companyData();
        showdata();
    }, []);

    const showdata = () => {
        const item = localStorage.getItem("name");
        // console.log(item, "itemitem--");
        setData(item);
    };

    const open = Boolean(anchorEl3);
    const id = open ? "simple-popover" : undefined;

    const handleRegisterModalOpen = () => {
        history.push(`/insideworkspace/${b[2]}`);
    };

    const companyData = async () => {
        try {
            const res = await GetAllCompanyData();
            if (res.status === 200) {
                setAllCompany(res.data.getAllCompanyData);
            }
        } catch (error) {
            console.log(error.message, "error");
        }
    };

    const getAllIrData = async () => {
        const res = await getAllIR();
        if (res.status === 200) {
            setAllIR(res.data.fetchIR);
        }
    };

    const AllRegisterData = async () => {
        GetCompanyDataIR(b[2]).then(response => {
            setIrData(response.data.updatedOtherData);
        }).catch(error => {
            console.log("error", error)
        })
    };

    const CompanyName = (c_id) => {
        try {
            const nameCompany = allCompany.filter((adj) => adj._id === c_id);
            const result = nameCompany[0]?.company_name
                ? nameCompany[0]?.company_name
                : "";
            return result;
        } catch (error) {
            // console.log(error, "2222");
            return 0;
        }
    };

    const handleClick = (event, data) => {
        setAnchorEl3(event.currentTarget);
        setIRData(data);
    };

    const handleClose = () => {
        setAnchorEl3(null);
    };

    const handleEditIr = (data) => {
        history.push(`/edit-investment/${registerID}/${data._id}`);
    };

    const handleDeleteIr = async (data) => {
        swal({
            title: "Are you sure to delete this IR?",
            text: "You won't be able to restore it!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                const Ir_id = data._id;
                try {
                    await deleteOthersDetailsIr(Ir_id);
                    AllRegisterData();
                    setAnchorEl3(null);
                    swal("IR Deleted Successfully", {
                        icon: "success",
                    });
                } catch (err) {
                    swal("Error!", err.message || "Something went wrong.", "error", {
                        button: "OK",
                    });
                }
            }
        });
    };

    return (
        <>
            <div className={commoncss.pageLayout}>
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <IRMenu
                        activeTab={"Investments"}
                        registerID={b[2]}
                    />
                    <motion.div
                        initial={{ x: 200, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 200, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        className={investmentRegisterCss.irLayout}
                    >
                        <div className={investmentRegisterCss.iRContainer}>
                            <div className={investmentRegisterCss.iRHeader}>
                                <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<DownloadIcon height={16} />}
                                    label="Export"
                                />
                                <Button
                                    btnColor={buttoncss.primary}
                                    icon={<PlusIcon />}
                                    label="Create Investment"
                                    onClick={() => { history.push(`/create-investment/${registerID}`) }}
                                />
                            </div>
                            <div className={investmentRegisterCss.iRDataContainer}>
                                {IrData.length === 0 ? (
                                    <></>
                                ) : (
                                    <>
                                        <div>
                                            <table className={investmentRegisterCss.irTable}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ borderTopLeftRadius: "20px",textAlign:"left",paddingLeft:"20px" }}>Investees</th>
                                                        <th>Investment value</th>
                                                        <th>Number of shares</th>
                                                        <th>Percentage holding</th>
                                                        <th>Nature of relationship</th>
                                                        <th style={{ borderTopRightRadius: "20px" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {IrData.map((row, index) => (
                                                        <tr key={index}>
                                                            <td style={{ textAlign:"left",paddingLeft:"20px",cursor:"pointer" }} onClick={()=> { history.push(`/investmentregister/${registerID}/${row._id}`)} }>{CompanyName(row.investment_company_id)}</td>
                                                            <td>{(Number(row?.value_of_investment)) + (Number(row?.totalValueOfInvestment))}{" "}</td>
                                                            <td>{Number(row.no_of_shares) + Number(row.totalHoldings)}</td>
                                                            <td>{Number(row.holdings) + Number(row.totalHoldings)}</td>
                                                            <td>{row.nature_of_relationship}</td>
                                                            <td>
                                                                <MenuDotsIcon
                                                                    onClick={(e) => handleClick(e, row)}
                                                                    style={{ cursor: "pointer", marginRight: 20 }}
                                                                />
                                                                <Popover
                                                                    id={id}
                                                                    open={open}
                                                                    anchorEl={anchorEl3}
                                                                    onClose={handleClose}
                                                                    anchorOrigin={{
                                                                        vertical: "bottom",
                                                                        horizontal: "left",
                                                                    }}
                                                                >
                                                                    <div className={investmentRegisterCss.irOptions}>
                                                                        <span
                                                                            style={{ borderBottom:"1px solid #EAEEED" }}
                                                                            onClick={() => {
                                                                                handleEditIr(IrOneData);
                                                                                handleClose();
                                                                            }}
                                                                        >
                                                                            Edit Investment
                                                                        </span>
                                                                        <span
                                                                            onClick={() => {
                                                                                handleDeleteIr(IrOneData);
                                                                                handleClose();
                                                                            }}
                                                                        >
                                                                            Delete Investment
                                                                        </span>
                                                                    </div>
                                                                </Popover>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </>
    );
};
export default IRDetails;
